import Vue from 'vue';

var localPageData = {
  props: {
    localPageData: {
      type: Object,
      required: false
    }
  },
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  }
};

var entry = {
  mixins: [localPageData],
  props: {
    entryData: {
      type: Object,
      required: true
    }
  }
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var EventHub = {
  Bus: new Vue(),
  TYPES: {
    RE_INIT_IMAGE_MAP: 're-initialize-image-map',
    START_PLAY_MEDIA: 'start-play-media',
    ANDROID_ACTIVITY_PAUSE: 'android-activity-pause',
    CLICKED_HOTSPOT_SPLASHSCREEN: 'clicked_hotspot_splashscreen'
  }
};

/**
 * Throttling enforces a maximum number of times a function can be called over time. As in “execute this function at most once every X milliseconds.”.
 * see http://demo.nimius.net/debounce_throttle/
 *
 * @param {function} fn throttled function
 * @param {integer} limit in milliseconds
 */
function throttle (fn) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var wait = false;
  var result;
  return function
    /* ...args */
  () {
    if (wait === false) {
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
      result = fn.apply(this, arguments); // eslint-disable-line
    }

    return result;
  };
}

//
var script = {
  props: {
    value: {
      type: Number,
      required: true
    },
    isMediaProgressSlider: {
      type: Boolean,
      default: false
    },
    isPlaying: {
      type: Boolean
    },
    isReady: {
      type: Boolean
    },
    pinSize: {
      type: Number,
      default: 15
    },
    trackSize: {
      type: Number,
      default: 15
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: function validator(v) {
        return ['horizontal', 'vertical'].includes(v);
      }
    },
    length: {
      type: Number
    },
    seekable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      track: null,
      progress: null,
      pin: null,
      mouseDown: false,
      touchStartTime: 0,
      isSliderTap: false
    };
  },
  mounted: function mounted() {
    this.onTouchStart = throttle(this.onTouchStart, 200);
    this.onTouchMove = throttle(this.onTouchMove, 50);
    this.onTouchEnd = throttle(this.onTouchEnd, 200);
    this.track = this.$el.querySelector('.js-track');
    this.progress = this.$el.querySelector('.js-progress');
    this.pin = this.$el.querySelector('.js-pin');

    if (this.isMediaProgressSlider) {
      this.$el.classList.add('c-slider--media-progress-slider');
    } else {
      this.pin.style.height = this.pinSize + 'px';
      this.pin.style.width = this.pinSize + 'px';
    } // this.track.addEventListener('click', this.onTrackClick, true)


    if (this.orientation === 'horizontal') {
      this.$el.classList.add('c-slider--horizontal');
      this.track.style.height = this.trackSize + 'px';
      this.progress.style.height = this.trackSize + 'px';
      var length = this.length ? this.length + 'px' : '100%';
      this.$el.style.width = length;
      this.$el.style.height = this.pinSize + 'px';
    } else {
      this.$el.classList.add('c-slider--vertical');
      this.track.style.width = this.trackSize + 'px';
      this.progress.style.width = this.trackSize + 'px';

      var _length = this.length ? this.length + 'px' : '100%'; // this.progress.style.length = length


      this.$el.style.height = _length;
      this.$el.style.width = this.pinSize + 'px';
    }
  },
  beforeDestroy: function beforeDestroy() {// this.track.removeEventListener('click', this.onTrackClick)
  },
  methods: {
    onTouchStart: function onTouchStart(e) {
      e.preventDefault(); // To prevent the whole page scrolling on iPhone

      if (e.type === 'mousedown') this.mouseDown = true;
      var path = e.path || e.composedPath && e.composedPath();

      if (path.includes(this.pin)) {
        this.tapStartOffset = this.getEventOffset(e);
        this.isPinTap = true;
      } else {
        if (this.seekable) {
          this.isSliderTap = true;
          this.updateValue(this.getEventOffset(e));
          if (!this.isPlaying) this.$emit('pinTap');
        }
      }

      this.touchStartTime = Date.now();
      e.stopPropagation();
      this.$xp.navigation.showNav(true);
    },
    onTouchMove: function onTouchMove(e) {
      e.preventDefault(); // To prevent the whole page scrolling on iPhone

      if (this.mouseDown || e.type === 'touchmove') {
        if (this.isPinTap || this.isSliderTap) {
          var currentOffset = this.getEventOffset(e); // accept tolerance value of 10

          if (Math.abs(currentOffset - this.tapStartOffset) > 500) {
            this.isPinTap = false;
            console.log('onTouchMove() STOP isPinTap', e.type, e);
          } else {
            this.tapStartOffset = currentOffset;

            if (this.seekable) {
              this.updateValue(this.getEventOffset(e));
            }
          }
        }
      }

      e.stopPropagation();
      this.$xp.navigation.showNav(true);
    },
    onTouchEnd: function onTouchEnd(e) {
      if (e.type === 'mouseup') this.mouseDown = false;

      if (this.isPinTap) {
        var wasSeeking = Date.now() - this.touchStartTime > 400;
        console.log('wasSeeking:', wasSeeking, ', touchTime:', Date.now() - this.touchStartTime);

        if (!wasSeeking || !this.isPlaying) {
          console.log('pin tap');
          this.$emit('pinTap');
        }
      }

      this.isPinTap = false;
      this.isSliderTap = false;
      e.stopPropagation();
    },
    getEventOffset: function getEventOffset(e) {
      var offset;

      if (e.touches) {
        offset = this.getTouchOffset(e);
      } else {
        offset = this.getMouseOffset(e);
      }

      return offset;
    },
    getTouchOffset: function getTouchOffset(e) {
      var boundingRect = this.$el.getBoundingClientRect();

      if (this.orientation === 'horizontal') {
        return e.touches[0].clientX - boundingRect.left;
      } else {
        // console.log(`getTouchOffset: ${boundingRect.height} - ${e.touches[0].clientY} + ${boundingRect.top} = ${boundingRect.height - e.touches[0].clientY + boundingRect.top}`)
        return boundingRect.height - e.touches[0].clientY + boundingRect.top;
      }
    },
    getMouseOffset: function getMouseOffset(e) {
      var boundingRect = this.$el.getBoundingClientRect();

      if (this.orientation === 'horizontal') {
        return e.clientX - boundingRect.left;
      } else {
        return boundingRect.height - (e.clientY - boundingRect.top);
      }
    },
    updateValue: function updateValue(offset) {
      var value = offset / this.getTrackLength(); // console.log(`onTouchMove value: ${offset} / ${this.getTrackLength()} = ${value}`)

      if (value < 0) {
        this.$emit('update:value', 0);
      } else if (value >= 0 && value <= 1) {
        this.$emit('update:value', value);
      } else if (value > 1) {
        this.$emit('update:value', 1);
      }
    },
    getTrackLength: function getTrackLength() {
      if (this.track) {
        if (this.orientation === 'horizontal') {
          return this.track.clientWidth;
        } else {
          return this.track.clientHeight;
        }
      }

      return 0;
    }
  },
  computed: {
    progressStyle: function progressStyle() {
      if (this.orientation === 'horizontal') {
        return {
          width: this.getTrackLength() * this.value + 'px'
        };
      } else {
        return {
          height: this.getTrackLength() * this.value + 'px'
        };
      }
    },
    pinStyle: function pinStyle() {
      if (this.orientation === 'horizontal') {
        return {
          left: this.getTrackLength() * this.value + 'px'
        };
      } else {
        return {
          bottom: this.getTrackLength() * this.value + 'px'
        };
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "c-slider",
      on: {
        touchstart: _vm.onTouchStart,
        mousedown: _vm.onTouchStart,
        touchmove: _vm.onTouchMove,
        mousemove: _vm.onTouchMove,
        touchend: _vm.onTouchEnd,
        mouseup: _vm.onTouchEnd
      }
    },
    [
      _c("div", { staticClass: "c-slider__track js-track" }, [
        _c("div", {
          staticClass: "c-slider__progress js-progress",
          style: _vm.progressStyle
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-slider__pin js-pin",
            style: _vm.pinStyle,
            attrs: { role: "button", tabindex: "0", "aria-label": "Play/Pause" }
          },
          [
            _vm.isMediaProgressSlider && !_vm.isReady
              ? _c("span", {
                  staticClass: "xp xp-spinner is-spinning xp--large",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isMediaProgressSlider && _vm.isReady && !_vm.isPlaying
              ? _c("span", {
                  staticClass: "xp xp-play xp--large",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isMediaProgressSlider && _vm.isReady && _vm.isPlaying
              ? _c("span", {
                  staticClass: "xp xp-pause xp--large",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e()
          ]
        )
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var lipSync = {
  mounted: function mounted() {
    this.lipSyncConnection = null;
    this.player = null;
    this.lipSyncPageId = 0;
    this.maxLatency = 0;
  },
  methods: {
    startLipSync: function startLipSync(player) {
      this.player = player;
      this.isAudio = player.nodeName === 'AUDIO';
      console.log('lipsync player:', this.player);
      var maxLipsyncLatency = this.$xp.settings.mergedSettings.maxLipsyncLatency;
      this.maxLatency = this.isAudio ? maxLipsyncLatency.audio : maxLipsyncLatency.video;
      console.log('lipsync max latency: ' + this.maxLatency);
      this.lipSyncPageId = parseInt(this.$route.params.id);
      this.retryConnect = 0;
      this.connectLipSyncServer();
    },
    stopLipSync: function stopLipSync() {
      if (this.lipSyncConnection) {
        this.lipSyncConnection.close();
      }
    },
    connectLipSyncServer: function connectLipSyncServer() {
      var _this = this;

      this.ntpOffset = 9999999999;
      this.ntpCount = 0;
      this.deltaPlayPos = 0;
      this.seekLatency = this.isAudio ? 230 : 1200; // preset value

      this.seekLatencyHistory = [this.seekLatency];
      this.retryConnect++;
      var url = this.lipSyncUrl;

      if (url.match(/<servername>/)) {
        var baseUrl = this.$xp.settings.baseUrl;
        var matches = /^http.?:\/\/([^/]+)\/.*$/.exec(baseUrl);

        if (matches) {
          url = url.replace(/<servername>/, matches[1]);
        }
      }

      this.lipSyncConnection = new WebSocket(url);
      this.syncing = true;
      this.seekLatencyIgnoreFirst = true;

      this.lipSyncConnection.onopen = function (e) {
        _this.onConnectionOpen(e);
      };

      this.lipSyncConnection.onerror = function (e) {
        _this.onConnectionError(e);
      };

      this.lipSyncConnection.onmessage = function (e) {
        _this.onConnectionMessage(e);
      };

      this.lipSyncConnection.onclose = function (e) {
        _this.onConnectionClose(e);
      };
    },
    onConnectionOpen: function onConnectionOpen(error) {
      console.log(error);
      this.sendNtpReq();
    },
    onConnectionError: function onConnectionError(error) {
      var _this2 = this;

      console.log(error);

      if (this.lipSyncConnection) {
        this.lipSyncConnection.close();
        this.lipSyncConnection = null;
      }

      if (this.retryConnect < 10) {
        setTimeout(function () {
          _this2.connectLipSyncServer();
        }, 1000);
      }
    },
    sendNtpReq: function sendNtpReq() {
      var data = {
        Type: 'NTP',
        Req: Date.now(),
        PageID: parseInt(this.$route.params.id)
      };
      this.lipSyncConnection.send(JSON.stringify(data));
    },
    onConnectionMessage: function onConnectionMessage(e) {
      var data = null;

      try {
        data = JSON.parse(e.data);
      } catch (e) {
        console.log(e);
      }

      if (data) {
        switch (data.Type) {
          case 'NTP':
            this.onNtpMessage(data);
            break;

          case 'POS':
            if (!this.syncing) {
              this.onPosMessage(data);
            }

            break;
        }
      }
    },
    onNtpMessage: function onNtpMessage(data) {
      // check if this is the right page for the current video
      var currentPageId = parseInt(this.$route.params.id);

      if (currentPageId !== this.lipSyncPageId) {
        this.stopLipSync();
      } else if (data.PageID !== null && data.PageID !== this.lipSyncPageId) {
        console.log('lipsync: redirect to page ' + data.PageID);
        this.stopLipSync();
        this.$router.replace({
          path: '/page/' + data.PageID,
          query: {
            replace: true
          }
        });
      }

      var now = Date.now();
      var offset = Math.round(now - data.Timestamp + (now - data.Req) / 2);
      this.ntpCount++;

      if (offset < this.ntpOffset) {
        this.ntpOffset = offset;
        console.log('ntpOffset=' + this.ntpOffset);
      }

      if (this.ntpCount < 10) {
        this.sendNtpReq();
      } else {
        this.syncing = false;
      }
    },
    onPosMessage: function onPosMessage(data) {
      var _this3 = this;

      // check if this is the right page for the current video
      var currentPageId = parseInt(this.$route.params.id);

      if (currentPageId !== this.lipSyncPageId) {
        this.stopLipSync();
      } else if (data.PageID !== null && data.PageID !== this.lipSyncPageId) {
        this.$router.replace({
          path: '/page/' + data.PageID,
          query: {
            replace: true
          }
        });
      }

      if (!this.ready) {
        if (this.autoPlay) {
          // if (this.video) { this.video.play() } else if (this.sound) { this.sound.play() }
          this.player.play();
        }

        this.ready = true;
      }

      var now = Date.now() - this.ntpOffset;
      var currentDelta = now - this.player.currentTime * 1000;
      this.deltaPlayPos = data.DeltaPlayPos;

      if (this.player.paused || Math.abs(currentDelta - this.deltaPlayPos) > this.maxLatency) {
        this.player.currentTime = (now - this.deltaPlayPos + this.seekLatency) / 1000;
        setTimeout(function () {
          var now = Date.now() - _this3.ntpOffset;

          var currentDelta = now - _this3.player.currentTime * 1000;
          var seekLatency = currentDelta - _this3.deltaPlayPos;

          _this3.setSeekLatency(seekLatency);
        }, 400);
        console.log('SET DD:' + (currentDelta - this.deltaPlayPos) + ', deltaPlayPos:' + this.deltaPlayPos + ', currentDelta:' + currentDelta + ', latency:' + (currentDelta - this.deltaPlayPos));
      }
    },
    onConnectionClose: function onConnectionClose() {
      this.retryConnect = 0;
      this.player.pause();
    },
    setSeekLatency: function setSeekLatency(newValue) {
      if (this.seekLatencyIgnoreFirst) {
        this.seekLatencyIgnoreFirst = false;
      } else {
        if (Math.abs(newValue) < 500) {
          var seekLatency = Math.floor(newValue + this.seekLatency);
          this.seekLatencyHistory.push(seekLatency);
          if (this.seekLatencyHistory.length > 5) this.seekLatencyHistory.shift();
          var sum = 0;
          var div = 0;

          for (var i = 0; i < this.seekLatencyHistory.length; i++) {
            sum += this.seekLatencyHistory[i] * (i + 1);
            div += i + 1;
          }

          console.log('seekLatencyHistory:' + this.seekLatencyHistory);
          this.seekLatency = Math.floor(sum / div);
          console.log('correct seekLatency(' + newValue + ') => ' + this.seekLatency);
        } else {
          console.warn('seekLatency:' + (this.seekLatency + newValue));
        }
      }
    }
  }
};

var script$1 = {
  mixins: [lipSync],
  props: {
    source: {
      default: ''
    },
    poster: {
      default: ''
    },
    autoPlay: {
      default: false
    },
    loop: {
      default: false
    },
    muted: {
      default: false
    },
    showControls: {
      default: true
    },
    binaryId: null,
    subtitles: null,
    lipSyncUrl: {
      type: String,
      default: null,
      validator: function validator(value) {
        return value === null || (typeof value === 'string' || value instanceof String) && value.startsWith('ws://');
      }
    }
  },
  data: function data() {
    return {
      showVolumeControl: false,
      playing: false,
      showPlayAgain: false,
      progress: 0,
      duration: 0,
      ready: false,
      isSeeking: false,
      sliderVirtualPosition: 0,
      isIos: this.$xp.device.platform === 'ios' || this.$xp.device.isIPhoneOrPad,
      showSubtitles: false,
      textTrackCueLine: 0,
      shouldShowIosControls: false
    };
  },
  computed: {
    track: {
      get: function get() {
        if (this.isSeeking && !this.isLipSync) {
          return this.sliderVirtualPosition;
        } else {
          return this.progress;
        }
      },
      set: function set(v) {
        if (this.video) {
          if (!Number.isNaN(v)) {
            this.sliderVirtualPosition = v;
            this.video.currentTime = v * this.duration;
          } else {
            console.log('vPlayer invalid time :' + v);
          }
        }
      }
    },
    playbackVolume: {
      get: function get() {
        return parseFloat(this.$xp.media.volume);
      },
      set: function set(v) {
        this.$xp.media.setGlobalVolume(v);
        this.video.volume = v;
      }
    },
    isLipSync: function isLipSync() {
      return this.lipSyncUrl != null;
    },
    ariaRemaingingTime: function ariaRemaingingTime() {
      var remaingingSeconds = this.duration - this.progress * this.duration;
      var minutes = Math.floor(remaingingSeconds / 60);
      var seconds = Math.floor(remaingingSeconds % 60);
      return this.$t('global.ariaRemainingTime', [minutes, seconds]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // const oldVideo = this.$el.querySelector('video')
    // if (oldVideo) {
    //   console.log('OLD VIDEO HEREEEEEEEEEEEEEEEEEEEEEEEE!!!!!!!!!!!!!!')
    //   this.$el.removeChild(oldVideo)
    // }
    this.IsIos = this.$xp.device.platform === 'ios' || this.$xp.device.isIPhoneOrPad;
    console.log(this.$xp.device.platform, this.$xp.device.isIPhoneOrPad, this.IsIos, this.$xp.device.isSafari);
    this.$xp.device.getRemappedUrl(this.source).then(function (remappedUrl) {
      if (_this.$xp.device.platform === 'ios') {
        if (window.XpedeoPreloader) {
          remappedUrl = window.XpedeoPreloader.convertProxyUrl(remappedUrl);
        }
      }

      console.log('lipsyncUrl', _this.lipSyncUrl);
      _this.video = document.createElement('video');

      _this.video.classList.add('c-video-player__element'); // if (window.device.platform.toLowerCase() !== 'ios')


      _this.video.controls = false;
      _this.video.src = remappedUrl;
      _this.video.type = 'audio/mp4';
      _this.video.loop = _this.loop;
      console.log('showControls', _this.showControls);
      _this.video.showControls = _this.showControls;
      _this.video.crossOrigin = 'anonymous';

      if (_this.poster !== null && _this.poster !== '') {
        _this.video.poster = _this.poster;
      }

      _this.video.disableRemotePlayback = true;
      _this.video.playsInline = true;

      if (_this.muted) {
        _this.volumeBeforeMute = _this.$xp.media.volume;
        _this.video.volume = 0;
      } else {
        _this.video.volume = _this.$xp.media.volume;
      }

      _this.video.load();

      if (_this.isIos) {
        _this.video.autoPlay = false;
      }

      if (_this.$el.prepend) {
        _this.$el.prepend(_this.video);
      } else {
        _this.$el.insertBefore(_this.video, _this.$el.firstChild);
      }

      _this.video.addEventListener('loadedmetadata', _this.onLoadedMetadata);

      if (_this.isIos) {
        _this.video.addEventListener('webkitbeginfullscreen', _this.enteredFullscreen);

        _this.video.addEventListener('webkitendfullscreen', _this.exitedFullscreen);
      }

      _this.video.addEventListener('canplaythrough', _this.onCanPlayThrough);

      _this.video.addEventListener('play', _this.onVideoPlay);

      _this.video.addEventListener('pause', _this.onVideoPause);

      _this.video.addEventListener('timeupdate', _this.onTimeUpdate);

      _this.video.addEventListener('ended', _this.onVideoEnded);

      _this.video.addEventListener('seeking', _this.onSeeking);

      _this.video.addEventListener('seeked', _this.onSeeked);

      if (_this.subtitles && _this.subtitles.BinaryID !== null) {
        if (_this.$xp.settings.mergedSettings.showSubtitlesDefault) {
          _this.showSubtitles = true;
        } else {
          _this.showSubtitles = _this.$xp.media.showSubtitles;
        }
      }
    });
    EventHub.Bus.$on(EventHub.TYPES.START_PLAY_MEDIA, function (uid) {
      if (_this.video && _this._uid !== uid) {
        _this.video.pause();
      }
    });
    window.addEventListener('keyup', this.onKeyEvent); // if (this.isIos) {
    //   if (window.StatusBar) {
    //     if (window.StatusBar.isVisible) {
    //       console.log('hide while creating video')
    //       window.StatusBar.hide()
    //     } else {
    //       console.log('not visible')
    //     }
    //   }
    // }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isIos) {
      if (!this.$xp.settings.mergedSettings.showSubtitlesDefault) {
        if (this.video.textTracks[0].mode === 'showing' && !this.$xp.media.showSubtitles) {
          this.$xp.media.setShowSubtitles(true);
        } else if (this.video.textTracks[0].mode === 'hidden' && this.$xp.media.showSubtitles) {
          this.$xp.media.setShowSubtitles(false);
        }
      }

      console.log('in ios sub condition, b4destroy in vPlayer');
    }

    this.video.autoplay = false;
    this.video.pause();
    this.$emit('media-session-ended');

    if (this.isLipSync) {
      this.stopLipSync();
      this.$xp.wifi.releaseWifiConnectionOn('videoSync');
    }

    this.video.removeEventListener('loadedmetadata', this.onLoadedMetadata);
    this.video.removeEventListener('canplaythrough', this.onCanPlayThrough);
    this.video.removeEventListener('play', this.onVideoPlay);
    this.video.removeEventListener('pause', this.onVideoPause);
    this.video.removeEventListener('timeupdate', this.onTimeUpdate);
    this.video.removeEventListener('ended', this.onVideoEnded);
    this.video.removeEventListener('seeking', this.onSeeking);
    this.video.removeEventListener('seeked', this.onSeeked);
    this.video.removeEventListener('keyup', this.onKeyEvent);
    EventHub.Bus.$off(EventHub.TYPES.START_PLAY_MEDIA, this.onStartPlayMedia);

    if (this.muted) {
      this.$xp.media.setGlobalVolume(this.volumeBeforeMute);
    }

    this.video.parentNode.removeChild(this.video);
    this.video.removeAttribute('src');
    this.video.load();
    this.video = null; // if (this.isIos) {
    //   if (window.StatusBar.isVisible) {
    //     console.log('StatusBar i s visible, hiding it.')
    //     window.StatusBar.hide()
    //   } else { console.log('not visible') }
    // }
  },
  methods: {
    onLoadedMetadata: function onLoadedMetadata() {
      console.log('onLoadedMetadata', this.video.duration, this.video.currentTime, this.video.play);

      if (this.video) {
        this.duration = this.video.duration;
      }

      if (this.subtitles && this.subtitles.BinaryID !== null) {
        this.loadSubtitles();
        var subButton = document.getElementsByClassName('c-video-player__subtitles-button');

        if (this.showSubtitles) {
          subButton[0].classList.add('c-subButton-active');
        } else {
          subButton[0].classList.add('c-subButton-inactive');
        }
      }
    },
    loadSubtitles: function loadSubtitles() {
      var _this2 = this;

      var ttrack = document.createElement('track');
      ttrack.src = this.subtitles.Url;
      ttrack.kind = 'subtitles';
      ttrack.srclang = this.subtitles.srclang;
      ttrack.label = this.subtitles.label;
      ttrack.default = true;
      var oVideo = this.video;
      ttrack.addEventListener('load', function () {
        console.log('subs are loaded');
        var aCues = oVideo.textTracks[0].cues;

        for (var n = 0; n < aCues.length; n++) {
          aCues[n].line = -1;
          aCues[n].size = 90;
        }

        if (_this2.showSubtitles) {
          console.log('subs are showing');
          _this2.mode = 'showing';
        } else {
          console.log('subs are hiding');
          _this2.mode = 'hidden';
        }

        if (_this2.isIos) {
          console.log('in load subs', oVideo.webkitClosedCaptionsVisible);
          oVideo.webkitClosedCaptionsVisible = _this2.showSubtitles;
          console.log('in load subs', oVideo.webkitClosedCaptionsVisible);
        }
      });
      ttrack.className = 'subtitlesTrack';
      this.video.appendChild(ttrack);

      var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
      }(!window.safari || typeof window.safari !== 'undefined' && window.safari.pushNotification);

      if (isSafari || this.isIos) {
        console.log('identified Safari');
        this.video.classList.add('stupidSafariSubs');
      }
    },
    onCanPlayThrough: function onCanPlayThrough() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var shouldRestoreState, historyCurrentTime, historyPlayingState, videoPromise;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.video) {
                  _context.next = 20;
                  break;
                }

                if (!_this3.isLipSync) {
                  _context.next = 10;
                  break;
                }

                if (_this3.ready) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return _this3.$xp.wifi.lockWifiConnectionOn('videoSync');

              case 5:
                _context.next = 7;
                return _this3.$xp.network.waitForOnline();

              case 7:
                _this3.startLipSync(_this3.video);

              case 8:
                _context.next = 20;
                break;

              case 10:
                console.log('onCanPlayThrough');
                shouldRestoreState = !_this3.ready && _this3.$route.query.ref !== 'beacon';
                console.log('shouldRestoreState: ' + shouldRestoreState);
                historyCurrentTime = _this3.$xp.history.historyParams['currentTime' + _this3.binaryId];
                console.log('restore time to = ' + historyCurrentTime);

                if (shouldRestoreState && historyCurrentTime) {
                  console.log('restore time to2 = ' + historyCurrentTime);
                  _this3.video.currentTime = historyCurrentTime;

                  if (_this3.video.currentTime >= _this3.video.duration - 1) {
                    _this3.showPlayAgain = true;
                  }
                }

                historyPlayingState = _this3.$xp.history.historyParams['isPlaying' + _this3.binaryId];

                if (shouldRestoreState && typeof historyPlayingState !== 'undefined') {
                  if (historyPlayingState) {
                    videoPromise = _this3.video.play();
                  } else {
                    videoPromise = _this3.video.pause();
                  }
                } else if (!_this3.ready && _this3.video && _this3.autoPlay) {
                  videoPromise = _this3.video.play();
                }

                if (videoPromise !== undefined) {
                  videoPromise.catch(function (error) {
                    console.log('Cannot Autoplay Video \n', error); // Auto-play was prevented
                    // Show a UI element to let the user manually start playback
                  });
                }

                _this3.ready = true;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onVideoPlay: function onVideoPlay() {
      // console.log('onVideoPlay')
      // console.log(this.video)
      this.setPlayingState(true);
      EventHub.Bus.$emit(EventHub.TYPES.START_PLAY_MEDIA, this._uid);
      this.$emit('media-playing');
    },
    onVideoPause: function onVideoPause() {
      // console.log('onVideoPause')
      this.setPlayingState(false);
      this.exitFullscreen();
    },
    setPlayingState: function setPlayingState(isPlaying) {
      this.playing = isPlaying;
      this.$xp.media.setIsMediaPlaying(isPlaying);
      this.$xp.history.setHistoryParam(parseInt(this.$route.params.id), 'isPlaying' + this.binaryId, isPlaying);
    },
    onTimeUpdate: function onTimeUpdate() {
      // console.log('onTimeUpdate')
      if (this.video && this.video.currentTime && this.ready) {
        this.progress = this.video.currentTime / this.video.duration;

        if (Math.floor(this.video.currentTime) % 10 === 0) {
          // postpone dimming every 10 seconds
          this.$xp.screen.postponeDim();
        }

        this.$xp.history.setHistoryParam(parseInt(this.$route.params.id), 'currentTime' + this.binaryId, this.video.currentTime);
      } else {
        // if (!this.isLipSync)
        this.progress = 0;
      }
    },
    onVideoEnded: function onVideoEnded() {
      console.log('onVideoEnded'); // record something if needed

      if (this.video && !this.loop) {
        this.video.pause(); // Jump a little bit back, so on going back to this page onVideoEnded() is not called automatically again

        this.video.currentTime -= 0.1;
        this.onTimeUpdate();
        this.setPlayingState(false);

        if (this.$xp.navigation.childPagesMenuItems.length && this.$xp.navigation.isChildPagesMenuHidden && !this.$xp.settings.mergedSettings.navigation.mediaIgnoresContextMenu) {
          this.$xp.navigation.toggleChildPagesMenu();
          this.showPlayAgain = true;
        } else if ((this.$xp.navigation.childPagesMenuItems.length === 0 || this.$xp.settings.mergedSettings.navigation.mediaIgnoresContextMenu) && this.$xp.history.nextPageId && this.$xp.settings.mergedSettings.navigation.nextPageOnMediaEnd) {
          this.$router.push('/page/' + this.$xp.history.nextPageId);
        } else if (this.$xp.navigation.childPagesMenuItems.length === 0 && this.$xp.settings.mergedSettings.navigation.backOnVideoEnd) {
          this.$xp.history.back();
        } else {
          // Erneut abspielen anbieten
          this.showPlayAgain = true;
        }
      }
    },
    onSeeking: function onSeeking() {
      // console.log('onSeeking')
      this.isSeeking = true;
    },
    onSeeked: function onSeeked() {
      // console.log('onSeeked')
      this.isSeeking = false;
    },
    onStartPlayMedia: function onStartPlayMedia(uid) {
      if (this.video && this._uid !== uid) {
        this.video.pause();
      }
    },
    togglePlayback: function togglePlayback() {
      console.log('togglePlayback', this.playing, this.showPlayAgain);

      if (this.video && this.ready) {
        if (!this.playing && this.showPlayAgain) {
          this.video.currentTime = 0;
          this.showPlayAgain = false;
          this.video.play();
        } else if (!this.playing) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }
    },
    stepForward: function stepForward() {
      console.log('Button: Video StepForward');
      this.video.currentTime += 15;
      this.onTimeUpdate();
    },
    stepBackward: function stepBackward() {
      console.log('Button: Video StepBackward');
      this.video.currentTime -= 15;
      this.showPlayAgain = false;
      this.onTimeUpdate();
    },
    onClickFullscreenPlay: function onClickFullscreenPlay() {
      if (this.video.webkitDisplayingFullscreen) {
        console.log('full screen'); // this.video.webkitExitFullscreen()
      } else {
        console.log('not full screen'); // this.video.webkitRequestFullScreen()

        if (this.video.webkitEnterFullscreen) {
          this.video.webkitEnterFullscreen();
        } else if (this.video.webkitRequestFullscreen) {
          this.video.webkitRequestFullscreen();
        }
      }

      this.togglePlayback();
    },
    exitFullscreen: function exitFullscreen() {
      if (this.isIos) {
        if (this.video.webkitExitFullscreen()) {
          this.video.webkitExitFullscreen();
        }
      }
    },
    enteredFullscreen: function enteredFullscreen() {
      console.log('now full screen');

      if (this.$el.webkitFullscreenElement) {
        console.log(this.$el.webkitFullscreenElement);
      }
    },
    exitedFullscreen: function exitedFullscreen() {
      console.log('exited fullscreen');

      if (this.$el.webkitFullscreenElement) {
        console.log(this.$el.webkitFullscreenElement);
      }
    },
    onKeyEvent: function onKeyEvent(e) {
      var nKey = e.keyCode; // console.log("onKeyEvent " + nKey);

      switch (nKey) {
        case 27:
          // ESC
          console.log('KeyEvent: Audio StopPlay');
          this.video.pause();
          break;

        case 32: // Space

        case 75:
          // K
          console.log('KeyEvent: Video TogglePlay');
          this.togglePlayback();
          break;

        case 37:
          // <-
          console.log('KeyEvent: Video Backward');
          this.video.currentTime -= 15;
          this.onTimeUpdate();
          break;

        case 39:
          // ->
          console.log('KeyEvent: Video Forward');
          this.video.currentTime += 15;
          this.onTimeUpdate();
          break;

        /** NO NEED for volum control in browser */
        // case 38: // arrow up
        //   if (this.$xp.media.showVolumeControl) {
        //     console.log('KeyEvent: Video Volume Up', this.playbackVolume)
        //     this.playbackVolume = Math.min(this.playbackVolume + 1, 200)
        //   }
        //   break
        // case 40: // arrow down
        //   if (this.$xp.media.showVolumeControl) {
        //     console.log('KeyEvent: Video Volume Down', this.playbackVolume)
        //     this.playbackVolume = Math.max(this.playbackVolume - 1, 0)
        //   }
        //   break
      }
    },
    onSubtitlesClick: function onSubtitlesClick() {
      if (this.showSubtitles) {
        this.showSubtitles = false;
        this.video.textTracks[0].mode = 'hidden';
      } else {
        this.showSubtitles = true;
        this.video.textTracks[0].mode = 'showing';
      }

      if (!this.$xp.settings.mergedSettings.showSubtitlesDefault) {
        this.$xp.media.setShowSubtitles(this.showSubtitles);
      }
    }
  },
  components: {
    Slider: __vue_component__
  },
  watch: {
    '$xp.navigation.isNavHidden': function $xpNavigationIsNavHidden(value) {
      if (value === true) {
        this.showVolumeControl = false;
      }
    },
    progress: function progress() {
      this.$emit('media-progress-changed');

      if (this.subtitles && this.subtitles.BinaryID && this.showSubtitles) {
        var nCueLine = this.$xp.navigation.isNavHidden ? 16 : 16; // hier kann Position der Untertitel angepasst werden. 16 = ganz unten

        if (nCueLine !== this.textTrackCueLine) {
          // console.log('set Subtitles to line ', nCueLine)
          this.video.textTracks[0].mode = 'hidden';

          for (var i = 0; i < this.video.textTracks[0].cues.length; i++) {
            this.video.textTracks[0].cues[i].line = nCueLine;
          }

          this.video.textTracks[0].mode = 'showing';
          this.textTrackCueLine = nCueLine;
        }
      }
    },
    showSubtitles: function showSubtitles() {
      if (this.video.textTracks[0]) {
        if (this.showSubtitles) {
          this.video.textTracks[0].mode = 'showing'; // console.log('in showsubs watch', value)
        } else {
          this.video.textTracks[0].mode = 'hidden'; // console.log('in showsubs watch', value)
        }
      }
    },
    playing: function playing() {
      if (this.subtitles) {
        if (this.subtitles.BinaryID) {
          if (this.video.textTracks[0].mode === 'showing' && !this.showSubtitles) {
            this.video.textTracks[0].mode = 'hidden';
          } else if (this.video.textTracks[0].mode === 'hidden' && this.showSubtitles) {
            this.video.textTracks[0].mode = 'showing';
          }
        }
      }
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "c-video-player",
      class: { landscape: this.$xp.screen.orientation === "landscape-primary" },
      style: { backgroundImage: "url(" + this.poster + ")" }
    },
    [
      !_vm.playing && _vm.shouldShowIosControls
        ? _c(
            "div",
            {
              staticClass: "c-video-player__ios-play",
              on: { click: _vm.onClickFullscreenPlay }
            },
            [
              _c("span", {
                staticClass:
                  "c-panorama__hotspot-icon--default c-panorama__hotspot-icon xp xp--huge",
                attrs: { "aria-hidden": "true" }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.shouldShowIosControls
        ? _c(
            "div",
            {
              staticClass: "c-video-player__controls",
              class: {
                "is-hidden":
                  (_vm.$xp.navigation.isNavHidden && _vm.playing) ||
                  !_vm.showControls
              },
              attrs: { id: "mediaplayer" }
            },
            [
              _c(
                "div",
                { staticClass: "c-video-player__wrapper" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "c-video-player__duration",
                      attrs: {
                        role: "progressbar",
                        "aria-valuenow": (
                          _vm.duration -
                          _vm.duration * _vm.progress
                        ).toFixed(),
                        "aria-valuetext": _vm.ariaRemaingingTime,
                        "aria-valuemin": "0",
                        "aria-valuemax": _vm.duration.toFixed(),
                        "aria-label": _vm.$t("global.remainingTime")
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("formatPlayTime")(
                              _vm.progress * _vm.duration - _vm.duration
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "vue-ellipse-progress",
                    {
                      attrs: {
                        angle: -90,
                        animation: "default 100 0",
                        color: "#fff",
                        dash: "0",
                        emptyColor: "rgba(0,0,0,.3)",
                        emptyThickness: "6",
                        fontColor: "white",
                        fontSize: "2rem",
                        legend: false,
                        legendClass: "legend-custom-style",
                        line: "butt",
                        lineMode: "in-over",
                        loading: false,
                        noData: false,
                        progress: _vm.progress * 100,
                        size: 90,
                        thickness: 6
                      }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "legend-value" },
                        slot: "legend-value"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          attrs: { slot: "legend-caption" },
                          slot: "legend-caption"
                        },
                        [
                          _c("div", { staticClass: "c-video-player__play" }, [
                            _c(
                              "button",
                              {
                                staticClass: "c-video-player__button",
                                class: { "not-ready": !this.ready },
                                attrs: {
                                  tabindex: "0",
                                  title: _vm.$t("global.play"),
                                  "aria-label": _vm.playing
                                    ? _vm.$t("global.pause")
                                    : _vm.$t("global.play")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.togglePlayback()
                                  }
                                }
                              },
                              [
                                _vm.playing
                                  ? _c("span", {
                                      staticClass: "xp xp-pause xp--large",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm.showPlayAgain
                                  ? _c("span", {
                                      staticClass:
                                        "xp xp-fast-rewind xp--large",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _c("span", {
                                      staticClass:
                                        "xp xp-video-audio-play xp--large",
                                      attrs: { "aria-hidden": "true" }
                                    })
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-video-player__ffrew" }, [
                    _c(
                      "button",
                      {
                        staticClass: "c-video-player__button",
                        attrs: {
                          tabindex: "0",
                          title: _vm.$t("global.rewind"),
                          "aria-label": _vm.$t("global.rewind")
                        },
                        on: {
                          click: function($event) {
                            return _vm.stepBackward()
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "xp xp-fast-rewind xp--large",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "c-video-player__button",
                        attrs: {
                          tabindex: "0",
                          title: _vm.$t("global.forward"),
                          "aria-label": _vm.$t("global.forward")
                        },
                        on: {
                          click: function($event) {
                            return _vm.stepForward()
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "xp xp-fast-forward xp--large",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.subtitles && _vm.subtitles.BinaryID !== null
                    ? _c(
                        "button",
                        {
                          staticClass: "c-video-player__subtitles-button",
                          attrs: {
                            tabindex: _vm.subtitles.BinaryID ? 0 : -1,
                            title: _vm.$t("global.showSubTitles")
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSubtitlesClick()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "xp xp--large xp-subtitles",
                            class: { "xp-subtitles-off": _vm.showSubtitles },
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-video-player__volume-wrapper" }, [
                    _vm.$xp.media.allowUIVolumeControl
                      ? _c(
                          "button",
                          {
                            staticClass: "c-video-player__volume-button",
                            attrs: {
                              tabindex: "0",
                              "aria-label": _vm.$t("global.setVolume")
                            },
                            on: {
                              click: function($event) {
                                _vm.showVolumeControl = !_vm.showVolumeControl;
                              }
                            }
                          },
                          [
                            _vm.$xp.media.volume >= 0.5
                              ? _c("i", {
                                  staticClass: "xp xp-volume-up xp--large",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$xp.media.volume < 0.5 &&
                            _vm.$xp.media.volume !== 0
                              ? _c("i", {
                                  staticClass: "xp xp-volume-down xp--large",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$xp.media.volume === 0
                              ? _c("i", {
                                  staticClass: "xp xp-volume-off xp--large",
                                  attrs: {
                                    "aria-hidden": "true",
                                    name: "$xp.media.volume-off"
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showVolumeControl
                      ? _c(
                          "div",
                          { staticClass: "c-video-player__volume-slider" },
                          [
                            _c("slider", {
                              attrs: {
                                value: _vm.playbackVolume,
                                orientation:
                                  this.$xp.screen.orientation ===
                                  "landscape-primary"
                                    ? "horizontal"
                                    : "vertical",
                                trackSize: 10,
                                length: 200
                              },
                              on: {
                                "update:value": function($event) {
                                  _vm.playbackVolume = $event;
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//
var script$2 = {
  mixins: [entry],
  components: {
    'video-player': __vue_component__$1
  },
  computed: {
    subtitles: function subtitles() {
      console.log('getSubtitles() ', this.entryData);

      if (this.entryData.Subtitles) {
        return {
          BinaryID: this.entryData.Subtitles.BinaryID,
          Url: this.$xp.settings.baseUrl + 'xpedeo/' + this.entryData.Subtitles.Url,
          srclang: this.entryData.Subtitles.srclang,
          label: this.entryData.Subtitles.label
        };
      }

      return null;
    },
    posterUrl: function posterUrl() {
      if (this.entryData.VideoThumb && this.entryData.VideoThumb.BinaryID > 0) {
        return this.$xp.content.getImageUrl(this.entryData.VideoThumb);
      } else {
        return null;
      }
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "js-entry o-entry c-video-entry" },
    [
      _vm.$xp.evaInstalled
        ? _c("video-player", {
            directives: [{ name: "eva-media", rawName: "v-eva-media" }],
            attrs: {
              source:
                _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Video.Url,
              binaryId: _vm.entryData.Video.BinaryID,
              pageId: _vm.entryData.Video.BinaryID,
              poster: _vm.posterUrl,
              autoPlay: _vm.entryData.Json.AutoPlay,
              loop: _vm.entryData.Json.Loop,
              muted: _vm.entryData.Json.Muted,
              showControls: _vm.entryData.Json.ShowControls,
              subtitles: _vm.subtitles,
              lipSyncUrl:
                _vm.pageData.Class === "XpVideoSync"
                  ? _vm.pageData.lipSyncUrl
                  : null
            }
          })
        : _c("video-player", {
            attrs: {
              source:
                _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Video.Url,
              binaryId: _vm.entryData.Video.BinaryID,
              pageId: _vm.entryData.Video.BinaryID,
              poster: _vm.posterUrl,
              autoPlay: _vm.entryData.Json.AutoPlay,
              loop: _vm.entryData.Json.Loop,
              muted: _vm.entryData.Json.Muted,
              showControls: _vm.entryData.Json.ShowControls,
              subtitles: _vm.subtitles,
              lipSyncUrl:
                _vm.pageData.Class === "XpVideoSync"
                  ? _vm.pageData.lipSyncUrl
                  : null
            }
          })
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__$2;
//# sourceMappingURL=VideoEntry.js.map
